module.exports = __webpack_public_path__ + "img/rascrut-2.b127e01e.jpg";